<div class="single-time-picker">
    <mat-form-field class="picker picker-width" appearance="legacy" floatLabel="never">
        <mat-label>{{showLabel}}</mat-label>
        <input #inputBox class="date-field-width date-picker-custom-input" data-input-type="time-component"
            [formControl]="timeFormControl" type="text" readonly="readonly" matInput>
        <mat-icon matSuffix class="time-p-icon">access_time</mat-icon>
    </mat-form-field>
</div>